import React from "react";

// inhouse icons
import { Search, X } from "@/components/icons_new";

// TODO: Change this component from reusable globally to only usable for Product parent page
const SearchFilterControls = ({
  searchTerm,
  updateSearchTerm,
  statusFilter,
  updateStatusFilter,
}) => {
  // Define the hardcoded filter tabs.
  const statuses = ["All", "Active", "Draft", "Archived"];

  return (
    <div className="mb-[1em] px-[0.5em] py-[0.5em] flex flex-col gap-[1em] border bg-white rounded-t-xl">
      
      <div className="bg-[#F8F8F8] relative px-3 py-2 rounded-md flex flex-row items-center gap-[1em]">
        <Search className="w-5 h-5 text-[#737373]" />

        {/* Implement the sidebar for search */}
        <input
          type="text"
          placeholder="Search for any product..."
          value={searchTerm}
        // sanitize users input
        // allow alphanum, space, dash, underscore, dot
        // limit to 100 characters
          onChange={(e) => {
            const raw = e.target.value;
            const sanitized = raw
              .replace(/[^a-zA-Z0-9\s\-_.]/g, "")
              .trim()
              .slice(0, 100);
            updateSearchTerm(sanitized);
          }}
          className="w-full text-[#000] bg-[#F8F8F8] placeholder:text-[#000] outline-none font-medium"
        />
        
        {/* clear button for the search terms in the search bar */}
        {searchTerm && (
          <button
            onClick={() => updateSearchTerm("")}
            className="absolute right-3 text-[#999] hover:text-black"
            aria-label="Clear search"
          >
            <X className="w-5 h-5 text-[#000000]" />
          </button>
        )}
      </div>

      {/* Status filter buttons */}
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex gap-2 w-full">
          {statuses.map((status) => (
            <button
              key={status}
              className={`px-4 py-2 rounded-md text-sm font-medium transition ${
                statusFilter === status ? "bg-[#E6E6E6]" : "bg-white"
              }`}
              onClick={() => updateStatusFilter(status)}
            >
              {status}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SearchFilterControls;